import type { FtoSimulationConfig, FtoExecutionResult } from './fto-simulation-config';

/**
 * FTO 检索导演服务接口
 * 负责协调整个 FTO 检索过程的模拟执行
 */
export interface FtoSearchDirectorService {
    /**
     * 运行 FTO 检索模拟
     * @param config 模拟配置
     * @returns Promise<FtoExecutionResult[]> 所有搜索轮次的执行结果
     */
    run(config: FtoSimulationConfig): Promise<FtoExecutionResult[]>;

    /**
     * 停止当前正在运行的模拟
     */
    stop(): Promise<void>;

    /**
     * 检查是否有模拟正在运行
     */
    isRunning(): boolean;

    /**
     * 获取当前运行状态
     */
    getRunningStatus(): {
        isRunning: boolean;
        totalRounds: number;
        completedRounds: number;
        runningRounds: number;
        failedRounds: number;
    };
}

export const FtoSearchDirectorService = Symbol('FtoSearchDirectorService');
